import { type FC } from 'react';
import { Button, HStack, Text } from '@direct-frontend/components';
import { getDashboardTodoListStepNavigationCaption } from '../../lib/getDashboardTodoListStepNavigationCaption';
import styles from './DashboardTodoListStepNavigation.module.css';

const ROOT_TEST_ID = 'DashboardTodoList.StepNavigation';

export type DashboardTodoListStepNavigationProps = {
    canMoveForward: boolean;
    canMoveBackward: boolean;
    moveBackwardAvailableForSeconds: number;
    isMovingBackward: boolean;
    isMovingForward: boolean;
    onMoveBackward: () => void;
    onMoveForward: () => void;
};

export const DashboardTodoListStepNavigation: FC<DashboardTodoListStepNavigationProps> = ({
    canMoveForward,
    canMoveBackward,
    moveBackwardAvailableForSeconds,
    isMovingBackward,
    isMovingForward,
    onMoveBackward,
    onMoveForward,
}) => {
    const caption = getDashboardTodoListStepNavigationCaption({
        canMoveForward,
        canMoveBackward,
        moveBackwardAvailableForSeconds,
    });

    return (
        <HStack alignItems="center" data-testid={ROOT_TEST_ID} gap="28">
            {canMoveBackward ? (
                <Button
                    color="contour"
                    data-testid={`${ROOT_TEST_ID}.Back`}
                    isLoading={isMovingBackward}
                    isDisabled={isMovingBackward}
                    size="s"
                    onClick={onMoveBackward}
                >
                    Открыть прошлый этап
                </Button>
            ) : null}
            <Text
                size="xs"
                textAlign="left"
                className={styles.caption}
                data-testid={`${ROOT_TEST_ID}.Caption`}
                role="supplementary"
            >
                {caption}
            </Text>
            {canMoveForward ? (
                <Button
                    color="contour"
                    data-testid={`${ROOT_TEST_ID}.Forward`}
                    isLoading={isMovingForward}
                    isDisabled={isMovingForward}
                    size="s"
                    onClick={onMoveForward}
                >
                    Следующий этап
                </Button>
            ) : null}
        </HStack>
    );
};
